import React, { useState, useEffect } from 'react';
import './Home.css';
import HeroBanner from '../../Components/HeroBanner/HeroBanner';
import UsageStatus from '../../Components/UsageStatus/UsageStatus';
import CategoriesDisplay from '../../Components/CategoriesDisplay/CategoriesDisplay';
import CategoryList from '../../Components/CategoryList/CategoryList';
import GetToKnow from '../../Components/GetToKnow/GetToKnow';
import LinearSlider from '../../Components/LinearSlider/LinearSlider';
import TestmonySection from '../../Components/TestmonySection/TestmonySection';
import TeacherSignin from '../../Components/TeacherSignin/TeacherSignin';
import FAQ from '../FAQ/FAQ';
import Footer from '../../Components/Footer/Footer';
import DiscountComponent from '../../Components/DiscountComponent/DiscountComponent';
import CategoryListView from '../../Components/CategoryListView/CategoryListView';
import MobileAppPromo from '../../Components/MobileAppPromo/MobileAppPromo';
import ExamBanner from '../../Components/ExamBanner/ExamBanner';

const Home = ({ isLoggedIn }) => { 
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // Check on load
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="home-container">
      <DiscountComponent />
      {isMobile ? (<MobileAppPromo isLoggedIn={isLoggedIn}/>):(<HeroBanner isLoggedIn={isLoggedIn} />)}
      {isMobile ? <ExamBanner /> : null}
      <CategoriesDisplay title="Most Popular Classes" />
      <CategoryList />
      <CategoriesDisplay title="Most Trend Classes" />
      <CategoryListView />
      <GetToKnow />
      <LinearSlider />
      <TestmonySection />
      <FAQ />
      <TeacherSignin />
      <Footer />
    </div>
  );
};

export default Home;
